export default __webpack_public_path__ + "static/media/Harness of the Ragereaver.58310a87.jpg";